import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const Documentation = lazy(() => import('@/pages/Documentation'));

function DocsSkeleton() {
  return (
    <div className="flex gap-6 animate-pulse">
      <div className="hidden lg:block w-64 space-y-3">
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-6 w-2/3" />
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-6 w-1/2" />
      </div>
      <div className="flex-1 space-y-4">
        <Skeleton className="h-10 w-2/3" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-64 w-full rounded-xl" />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/docs')({
  component: () => (
    <Suspense fallback={<DocsSkeleton />}>
      <Documentation />
    </Suspense>
  ),
});
